<div class="question-text-group">
  <rt-form-field [required]="isRequired()">
    <rt-label>
      {{ 'tlc.dynamic_form.define.question' | translate }}
    </rt-label>
    <rt-input variant="rounded" [formControl]="defineForm().controls.question" class="title" />
    <!--    @if (titleControl.errors?.required && titleControl.touched) {-->
    <!--      <span text-red padding-top-small-xx>{{-->
    <!--        'app.settings.referrals.questions.required_error' | translate-->
    <!--      }}</span>-->
    <!--    } @else if (titleControl.errors?.maxLength && titleControl.touched) {-->
    <!--      <span text-red padding-top-small-xx>{{-->
    <!--        'app.settings.referrals.questions.max_length_error' | translate-->
    <!--      }}</span>-->
    <!--    }-->
    @if (!hindDisabled()) {
      <rt-input
        [placeholder]="'tlc.dynamic_form.define.add_helper_text' | translate"
        [formControl]="defineForm().controls.hint"
        variant="rounded"
        class="hint"
      />
    }
  </rt-form-field>
</div>
